import { BottomMenuButtons, IBottomMenuButtonsRef } from "../../bottom-menu/buttons";

export type IBottomRootMenuRef = IBottomMenuButtonsRef;

export const BottomRootMenu = BottomMenuButtons; // At this moment we use the BottomMenuButtons
BottomRootMenu.displayName = "BottomRootMenu";
